import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { BUILD_INFO } from "../../shared/build-info";
import { Badge, Button, Drawer } from "../components/ui";

const links = [
  ["/admin", "Bảng điều khiển"],
  ["/admin/dogs", "Kiểm duyệt hồ sơ chó"],
  ["/admin/ownership", "Ownership & evidence"],
  ["/admin/pedigree", "Pedigree Engine"],
  ["/admin/roles", "Role & permission"],
  ["/admin/taxonomy", "Giống & taxonomy"],
  ["/admin/audit", "Audit log"],
  ["/admin/settings", "Site settings"],
  ["/admin/feature-flags", "Feature flags"],
  ["/admin/system", "Hệ thống & phiên bản"],
] as const;

export function AdminShell() {
  const [open, setOpen] = useState(false);
  const nav = (
    <nav className="side-nav" aria-label="Điều hướng quản trị">
      {links.map(([to, label]) => (
        <NavLink key={to} to={to} end={to === "/admin"} onClick={() => setOpen(false)}>
          {label}
        </NavLink>
      ))}
    </nav>
  );

  return (
    <div className="workspace-shell admin-theme">
      <aside className="workspace-sidebar">
        <NavLink className="brand brand-inverse" to="/">
          <span className="brand-mark">WD</span>
          <span>
            <strong>Quản trị</strong>
            <small>WorkingDog VN</small>
          </span>
        </NavLink>
        {nav}
        <div className="sidebar-build">
          <Badge tone="neutral">{BUILD_INFO.version}</Badge>
          <code>{BUILD_INFO.id.slice(0, 12)}</code>
        </div>
      </aside>
      <section className="workspace-main">
        <header className="workspace-topbar">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setOpen(true)}
            className="mobile-only"
          >
            Menu
          </Button>
          <div>
            <p className="eyebrow">Administration</p>
            <h1>Nền tảng vận hành</h1>
          </div>
          <NavLink className="text-link" to="/">
            Về trang công khai
          </NavLink>
        </header>
        <main className="workspace-content">
          <Outlet />
        </main>
        <footer className="technical-footer">
          Build <code>{BUILD_INFO.id}</code> · {BUILD_INFO.timestamp}
        </footer>
      </section>
      <Drawer open={open} title="Điều hướng quản trị" onClose={() => setOpen(false)}>
        {nav}
      </Drawer>
    </div>
  );
}
